import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Constant from "../../../utils/constant";
import { ITag } from "../../../model/interface/tag";
import { RefreshIcon } from "@heroicons/react/outline";
import { ColorPaletteIcon } from "../../../assets/icons/index";
import { DropdownItem } from "../../../model/interface/keyValuePair";
import getColors from "../../../model/tagColor";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { Link, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import Breadcrumb from "../../shared/common/breadcrumb";
import Select, { SingleValue } from "react-select";
import { updateTag, addTag, getTagById } from "../../../api/tag.service";
import Loader from "../../shared/loader/loader";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { toast } from "react-toastify";
import { useNumericParam } from "../../../utils/useNumericParam";

const ManageTag: React.FC<any> = (props: any) => {
  const navigate = useNavigate();
  const id = useNumericParam("id");
  const [tagToEdit, setTagToEdit] = useState<ITag>();
  const [contentAreas, setContentAreas] = useState<DropdownItem[]>([]);
  const [categorys, setCategorys] = useState<DropdownItem[]>([]);
  const [selectedContent, setSelectedContent] = useState<DropdownItem>();
  const [selectedCategory, setSelectedCategory] = useState<DropdownItem>();
  const [name, setName] = useState<string>();
  const [toggleColorPalette, setColorPalette] = useState<boolean>(false);
  const [color, setColor] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id) {
      getTag();
    } else {
      bindContentAreas();
      bindCategorys();
    }
  }, []);

  useEffect(() => {
    const tagPopup: any = document.getElementById("tagPopup");
    const tagPopupBtn: any = document.getElementById("tagPopupBtn");

    if (tagPopup) {
      window.onclick = function (event) {
        if (
          event.target !== tagPopup &&
          event.target !== tagPopupBtn &&
          toggleColorPalette
        ) {
          setColorPalette(false);
        }
      };
    }
  }, [toggleColorPalette]);

  async function getTag() {
    setLoading(true);
    const response = getTagById(id);
    const data = (await response).data;
    setTagToEdit(data);
    setColor(data.color);
    bindContentAreas(data);
    bindCategorys(data);
    setLoading(false);
  }

  const onSubmit = (data) => {
    setLoading(true);
    const tagData: ITag = {
      tagId: tagToEdit ? tagToEdit.tagId : 0,
      contentAreaId: selectedContent ? selectedContent.value : "",
      categoryId: selectedCategory ? selectedCategory.value : "",
      name: data.tagname,
      description: data.desciption,
      color: color,
      isActive: true,
    };

    if (tagToEdit && Object.keys(tagToEdit).length) {
      tagData.isActive = tagToEdit?.isActive;
    }

    tagToEdit
      ? updateTag(tagData).then(() => {
          setLoading(false);
          toast.success("Tag updated successfully");
          navigate(Constant.TAGS);
        })
      : addTag(tagData).then(() => {
          setLoading(false);
          toast.success("Tag added successfully");
          navigate(Constant.TAGS);
        });
  };

  function handleRandomColor() {
    const existingColors = getColors;
    const randomColor =
      existingColors[Math.floor(Math.random() * existingColors.length)];
    setColor(randomColor.code);
  }

  function handleContentAreaChange(
    selectedItem: SingleValue<DropdownItem> | null
  ) {
    if (!selectedItem) return;
    setSelectedContent(selectedItem);
    setName(`${selectedItem.label}-`);
  }

  function handleCategoryChange(selectedItem: any) {
    setSelectedCategory(selectedItem);
  }

  async function bindContentAreas(data?) {
    const service = await import("../../../api/contentArea.service");
    service.getContentArea(999, 1).then((response) => {
      const result = response.data.data;
      const dropdownData = result.map((item) => {
        return { label: item.name, value: item.contentAreaId };
      });
      setContentAreas(dropdownData);
      if (data && Object.keys(data).length) {
        let filter = dropdownData.filter(
          (ds) => ds.value === data.contentAreaId
        );
        if (filter.length) {
          filter = filter[0];
          setSelectedContent(filter);
        }
      }
    });
  }

  async function bindCategorys(data?) {
    const service = await import("../../../api/category.service");
    service.getCategorys().then((response) => {
      const result = response.data.data;
      const dropdownData = result.map((item) => {
        return { label: item.name, value: item.categoryId };
      });
      setCategorys(dropdownData);

      if (data && Object.keys(data).length) {
        let filter = dropdownData.filter((ds) => ds.value === data.categoryId);
        if (filter.length) {
          filter = filter[0];
          setSelectedCategory(filter);
        }
      }
    });
  }

  function handlePaletteClick(selectedColor: string) {
    setColor(selectedColor);
    setColorPalette(!toggleColorPalette);
  }

  function getTextColor() {
    let textColor = "";
    const selectedColor = getColors.filter((r) => r.code === color);
    if (selectedColor && selectedColor.length > 0) {
      if (selectedColor[0].isTextWhite) {
        textColor = "text-white ";
      }
    }

    return textColor;
  }

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Tag", url: Constant.TAGS },
      { name: tagToEdit ? "Edit Tag" : "Add Tag", url: "" },
    ];

    if (tagToEdit?.tagId) {
      items.push({
        name: "",
        url: "",
        objectId: tagToEdit?.tagId?.toString(),
      });
    }

    return items;
  };

  return (
    <AllowedTo
      perform={[Permissions.tag_create, Permissions.tag_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {tagToEdit ? "Edit Tag " : "Add Tag "}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="shadow border rounded-lg border-gray-300 rounded-md mt-4 px-4 py-6 w-1/4">
                <div>
                  <div className="grid grid-cols-1">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        Content Area
                      </label>
                    </div>
                    <div className="mt-1 text-sm">
                      <Select
                        value={selectedContent}
                        onChange={handleContentAreaChange}
                        options={contentAreas}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        className="text-gray-900 cursor-default select-none relative py-2"
                        isSearchable={true}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        Categories
                      </label>
                    </div>
                    <div className="mt-1 text-sm">
                      <Select
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        options={categorys}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        className="text-gray-900 cursor-default select-none relative py-2"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">Name</label>
                    </div>
                    <div>
                      <input
                        type="text"
                        defaultValue={tagToEdit?.name || name}
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        {...register("tagname", {
                          required: true,
                          value: tagToEdit?.name,
                        })}
                      />
                      {errors.tagname && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Name is required.
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        {" "}
                        Description
                      </label>
                    </div>
                    <div>
                      <input
                        type="text"
                        defaultValue={tagToEdit && tagToEdit.description}
                        autoComplete="off"
                        className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        {...register("desciption", {
                          required: false,
                        })}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">Color</label>
                    </div>
                    <div>
                      <input
                        id="color"
                        name="color"
                        value={color}
                        type="text"
                        autoComplete="off"
                        onChange={(e) => setColor(e.target.value)}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />

                      <div className="flex justify-end mt-5 space-x-2 cursor-pointer">
                        <span
                          id="tagPopupBtn"
                          className={`w-10 h-10 bg-[${color}] ${getTextColor()} cursor-pointer rounded-lg p-2 flex items-center justify-center `}
                          onClick={() => setColorPalette(!toggleColorPalette)}
                        >
                          <ColorPaletteIcon className="pointer-events-none w-5" />
                        </span>
                        <span className="cursor-pointer w-10 h-10 bg-gray-200 text-gray-700 rounded-lg p-2 flex items-center justify-center">
                          <RefreshIcon
                            onClick={() => handleRandomColor()}
                            className="w-5"
                          />
                        </span>
                      </div>
                    </div>
                  </div>

                  {toggleColorPalette && (
                    <div
                      id="tagPopup"
                      className={`rounded-md bg-white shadow p-2 w-72 ml-28 ${
                        toggleColorPalette ? "" : "hidden"
                      }`}
                    >
                      <div className="flex">
                        {[...Array(getColors.length / 9)].map((x, i) => (
                          <div key={i}>
                            {getColors.slice(i * 9, i * 9 + 9).map((color) => {
                              return (
                                <div
                                  key={color.id}
                                  onClick={() => handlePaletteClick(color.code)}
                                  className={`cursor-pointer w-6 h-6 rounded-full mx-1 my-1 bg-[${color.code}]`}
                                ></div>
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="flex justify-end mt-8 items-center border-t ">
                    <button className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                      {tagToEdit ? "Update " : "Save"}
                    </button>
                    <Link to={Constant.TAGS} className="ml-2">
                      <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(ManageTag);
